var _defs, _title, _title2, _title3, _title4, _title5, _title6, _title7, _title8, _title9, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCnhAberto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 39.31 53.122",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#b7d9cb;stroke:#334a52;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#334a52;}.cls-3{fill:#cef0e0;}.cls-4{fill:#e4f4eb;}"), /*#__PURE__*/React.createElement("style", {
    id: "style140"
  }, ".cls-1{fill:#b7d9cb;stroke:#334a52;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#334a52;}.cls-3{fill:#cef0e0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "cnh_mini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "matrix(0.3644663,0,0,0.3644663,-3.2919383,-4.3180925)",
    style: {
      display: "inline"
    }
  }, _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title2"
  }, "Foto 3x4")), /*#__PURE__*/React.createElement("path", {
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#faa980",
      stroke: "#000000"
    },
    d: "m 35.642,63.68 -1.067,2.628 c -0.086,6.095 7.599,6.99 7.697,-0.022 l -0.911,-2.439 z",
    id: "path6"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", {
    id: "title4"
  }, "Pesco\xE7o"))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#febb87",
      stroke: "#000000"
    },
    cx: 38.604,
    cy: 57.294998,
    rx: 5.8309999,
    ry: 7.4120002,
    id: "ellipse10"
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", {
    id: "title8"
  }, "Rosto"))), /*#__PURE__*/React.createElement("path", {
    d: "m 36.318,47.214 c -2.242,0.379 -3.521,1.77 -4.078,4.412 -0.425,2.016 -0.425,2.981 0,2.981 0.269,0 0.292,0.2 0.202,0.985 -0.158,1.075 0.044,2.6 0.336,2.6 0.09,0 0.245,-0.784 0.313,-1.749 0.066,-1.163 0.268,-2.083 0.584,-2.688 0.537,-1.075 0.537,-1.051 1.208,-0.605 0.628,0.402 1.389,0.45 4.413,0.223 3.049,-0.223 3.564,0 4.235,1.793 0.246,0.672 0.538,1.635 0.604,2.129 0.226,1.411 0.539,1.052 0.539,-0.65 0,-0.941 0.136,-1.792 0.336,-2.171 0.649,-1.234 -0.068,-4.102 -1.277,-5.132 -0.537,-0.472 -0.627,-0.628 -0.403,-0.897 0.223,-0.269 0.068,-0.382 -0.941,-0.65 -1.187,-0.358 -4.032,-0.807 -4.659,-0.785 -0.18,0.024 -0.831,0.114 -1.412,0.204 z",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    id: "path14"
  }, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", {
    id: "title12"
  }, "Cabelo"))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#f8eff8",
      stroke: "#000000"
    },
    points: "37.259,76.012 34.322,66.239 38.682,67.35 42.591,66.172 39.994,76.012 ",
    id: "polygon18"
  }, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", {
    id: "title16"
  }, "Camisa"))), /*#__PURE__*/React.createElement("path", {
    d: "m 34.28,66.212 c -0.204,0.336 -1.704,0.985 -5.288,2.331 -1.66,0.603 -3.228,1.255 -3.496,1.411 -0.671,0.426 -1.143,1.544 -1.435,3.361 -0.133,0.85 -0.291,1.837 -0.335,2.173 l -0.09,0.582 h 14.989 c 8.267,0 15.011,-0.067 15.011,-0.135 0,-0.827 -0.717,-4.211 -1.029,-4.862 -0.495,-1.075 -0.741,-1.209 -4.461,-2.576 -1.724,-0.649 -3.628,-1.412 -4.211,-1.724 -0.605,-0.293 -1.121,-0.515 -1.165,-0.471 -0.046,0.045 -0.673,2.128 -1.434,4.638 -0.741,2.508 -1.412,4.613 -1.459,4.683 -0.131,0.11 -0.288,-0.942 -0.467,-2.982 -0.09,-0.873 -0.226,-1.969 -0.335,-2.463 -0.16,-0.696 -0.114,-0.965 0.133,-1.255 0.292,-0.313 0.292,-0.447 0.044,-0.851 -0.158,-0.27 -0.447,-0.471 -0.627,-0.471 -0.178,0 -0.471,0.201 -0.626,0.471 -0.247,0.404 -0.247,0.538 0.021,0.83 0.267,0.289 0.291,0.603 0.158,1.388 -0.114,0.56 -0.269,1.949 -0.359,3.092 -0.089,1.141 -0.225,2.106 -0.315,2.171 -0.09,0.047 -0.627,-1.5 -1.21,-3.426 -1.68,-5.647 -1.858,-6.162 -2.014,-5.915 z",
    style: {
      vectorEffect: "non-scaling-stroke"
    },
    id: "path22"
  }, _title6 || (_title6 = /*#__PURE__*/React.createElement("title", {
    id: "title20"
  }, "Terno"))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#da172a",
      stroke: "#000000"
    },
    points: "37.405,76.066 38.24,69.701 38.218,69.292 37.693,68.498 38.331,67.606 38.945,67.606 39.561,68.54 39.052,69.316 39.037,69.716 39.962,75.468 40.024,76.073 ",
    id: "polygon26"
  }, _title7 || (_title7 = /*#__PURE__*/React.createElement("title", {
    id: "title24"
  }, "Gravata"))), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, _title8 || (_title8 = /*#__PURE__*/React.createElement("title", {
    id: "title28"
  }, "Terno dobrado")), /*#__PURE__*/React.createElement("polyline", {
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#797979",
      stroke: "#000000"
    },
    points: "35.414 76.073 36.64 75.294 37.783 72.449 36.531 72.291 37.83 70.059 34.064 66.057 32.066 66.056",
    transform: "rotate(180,34.948002,71.064499)",
    id: "polyline30"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#797979",
      stroke: "#000000"
    },
    points: "42.362 65.942 43.524 66.626 44.663 69.542 43.411 69.815 45.095 71.797 41.611 76.068 39.693 76.074",
    id: "polyline32"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "#ffffff",
      stroke: "#000000"
    },
    points: "40.518,69.428 38.993,67.493 38.295,67.492 36.623,69.518 34.369,66.193 35.235,64.372 38.262,67.25 39.021,67.25 41.658,64.349 42.5,66.263 ",
    id: "polygon38"
  }, _title9 || (_title9 = /*#__PURE__*/React.createElement("title", {
    id: "title36"
  }, "Colarinho")))), /*#__PURE__*/React.createElement("path", {
    id: "rect8-7",
    style: {
      display: "inline",
      vectorEffect: "non-scaling-stroke",
      fill: "#b7d9cb",
      stroke: "#334a52",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      InkscapeStroke: "hairline"
    },
    className: "cls-1",
    d: "m 3.5605469,1.0410156 c -1.4071586,0 -2.5410157,1.131904 -2.5410157,2.5390625 V 24.050781 c 0,1.407159 1.1338571,2.541016 2.5410157,2.541016 H 35.791016 c 1.407158,0 2.539062,-1.133857 2.539062,-2.541016 V 3.5800781 c 0,-1.4071585 -1.131904,-2.5390625 -2.539062,-2.5390625 z M 7.7402344,12.5 h 6.0605466 c 1.030439,0 1.859375,0.828936 1.859375,1.859375 v 7.089844 c 0,1.030439 -0.828936,1.861328 -1.859375,1.861328 H 7.7402344 c -1.030439,0 -1.859375,-0.830889 -1.859375,-1.861328 v -7.089844 c 0,-1.030439 0.828936,-1.859375 1.859375,-1.859375 z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 37.310001,
    height: 25.549999,
    rx: 2.54,
    id: "rect8",
    style: {
      display: "inline",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1,
    y: 1,
    width: 37.310001,
    height: 5.9099998,
    id: "rect10",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.85,
    y: 20.74,
    width: 5.9200001,
    height: 2.5699999,
    id: "rect12",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.32,
    y: 20.74,
    width: 8.4899998,
    height: 2.5699999,
    id: "rect14",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.85,
    y: 12.5,
    width: 15.96,
    height: 2.03,
    id: "rect16",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.85,
    y: 16.610001,
    width: 15.96,
    height: 2.0599999,
    id: "rect18",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.8800001,
    y: 8.6899996,
    width: 27.93,
    height: 2.03,
    id: "rect22",
    style: {
      display: "inline"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g168",
    transform: "translate(0.02333309,25.517929)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 37.310001,
    height: 25.549999,
    rx: 2.54,
    id: "rect146"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1,
    y: 1,
    width: 5.4499998,
    height: 14.28,
    id: "rect148"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.3900003,
    y: 21.59,
    width: 27.15,
    height: 2.5699999,
    id: "rect150"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.3900003,
    y: 13.25,
    width: 17.77,
    height: 2.03,
    id: "rect152"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.3900003,
    y: 16.77,
    width: 15.96,
    height: 2.0599999,
    id: "rect154"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.3900003,
    y: 3.1099999,
    width: 27.15,
    height: 7.9699998,
    id: "rect156"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnhAberto);
export default __webpack_public_path__ + "static/media/cnh_aberto.82f2a853f34ee4c5c109a79780c77115.svg";
export { ForwardRef as ReactComponent };